import { Route } from "react-router-dom";
import PreOnboarding from "../features/pre_onboarding";
import WelcomePreonboarding from "../features/pre_onboarding/components/WelcomePreonboarding";

export const preonboardingRoutes = (
    <>
        <Route
            path="/preonboarding"
            element={<PreOnboarding />}
            key="preonboarding"
        />
        <Route
            path="/welcome-preonboarding"
            element={<WelcomePreonboarding />}
            key="welcome_preonboarding"
        />
    </>
);
